export default class TrustindexLightboxModule {
	constructor(widget)
	{
		this.data = widget.TrustindexReviewImageModule.data;
		this.widget = widget;

		this.isLongScroll = 'popup' === this.widget.reviewTextMode;
		this.reviewMediaContainer = null;
	}

	init()
	{
		if (this.isLongScroll) {
			return this.initLongScroll();
		}

		let html = `<div class="ti-widget-lightbox" data-layout-id="${this.widget.layoutId}" data-set-id="${this.widget.setId}" data-pid="${this.widget.pid}">
			<div class="ti-widget-lightbox-close"></div>
			<div class="ti-widget-lightbox-inner">
				<div class="ti-widget-card">
					<div class="ti-card-body">
						<div class="ti-card-media">
							<img alt="" />
							<div class="ti-nav-arrow">
								<div class="ti-arrow-prev"></div>
								<div class="ti-arrow-next"></div>
							</div>
						</div>
						<div class="ti-review-content"></div>
					</div>
				</div>
			</div>
		</div>`;

		this.lightbox = this.createLightbox(html);
		this.image = this.lightbox.querySelector('.ti-card-media img');
		this.reviewContent = this.lightbox.querySelector('.ti-review-content');
		this.prevArrow = this.lightbox.querySelector('.ti-arrow-prev');
		this.nextArrow = this.lightbox.querySelector('.ti-arrow-next');
		this.currentIndex = 0;
		this.currentReview = null;

		this.addWidgetStyles();
		this.addEvents();
	}

	initLongScroll()
	{
		let html = `<div class="ti-widget-lightbox ti-long-scroll" data-layout-id="${this.widget.layoutId}" data-set-id="${this.widget.setId}" data-pid="${this.widget.pid}">
			<div class="ti-widget-lightbox-inner">
				<div class="ti-widget-lightbox-review-container">
					<div class="ti-widget-lightbox-review-container-inner"></div>
				</div>
			</div>
			<div class="ti-widget-lightbox-close" tabindex="0"></div>
			<div class="ti-widget-lightbox-mobile-close-bottom">${this.widget.locales.close}<span></span></div>
			<div class="ti-widget-lightbox-mobile-close-bottom-swipe"><span></span></div>
		</div>`;

		this.isMoving = false;
		this.lightbox = this.createLightbox(html);
		this.lightbox.reviewsContainer = this.lightbox.querySelector('.ti-widget-lightbox-review-container');
		this.lightbox.reviewsContainerInner = this.lightbox.querySelector('.ti-widget-lightbox-review-container-inner');
		this.lightbox.mobileCloseBottom = this.lightbox.querySelector('.ti-widget-lightbox-mobile-close-bottom');
		this.lightbox.mobileCloseBottomSwipe = this.lightbox.querySelector('.ti-widget-lightbox-mobile-close-bottom-swipe');

		if (this.widget.classList.contains('ti-custom-stars')) {
			this.lightbox.classList.add('ti-custom-stars');
		}

		this.widget.querySelectorAll('.ti-review-item').forEach(reviewItem => {
			let reviewContainer = document.createElement('div');
			reviewContainer.classList.add('ti-review-item');

			let reviewHeader = reviewItem.querySelector('.ti-review-header').cloneNode(true);
			reviewHeader.classList.add('ti-lightbox-review-header');

			let reviewText = reviewItem.querySelector('.ti-review-text-container').cloneNode(true);
			reviewText.setAttribute('class', 'ti-review-text ti-review-text-container')
			reviewText.setAttribute('style', "");
			reviewText.querySelectorAll('.ti-review-image').forEach(img => img.remove());

			reviewContainer.appendChild(reviewHeader);

			let starsContainer = reviewItem.querySelector('.ti-stars');
			if (starsContainer) {
				reviewContainer.appendChild(starsContainer.cloneNode(true));
			}

			let images = [];
			this.data.forEach(img => {
				if (img.r === reviewItem.getAttribute('data-id')) {
					images.push(img);
				}
			});

			if (images.length > 0) {
				let thumbnailsHtml = "";
				let mediaHtml = "";
				images.forEach((img, index) => {
					thumbnailsHtml += `<div class="ti-card-media-thumbnail" data-state="${index}"><img src="${img.thumbnail}" alt="" /></div>`;
					mediaHtml += `<div class="ti-card-media-image"><img src="${this.getImgSrc(img)}" alt="" /></div>`;
				});

				let imageMedia = (new DOMParser()).parseFromString(`
					<div class="ti-card-media">
						<div class="ti-card-media-images">${mediaHtml}</div>
						<div class="ti-nav-arrow">
							<div class="ti-arrow-prev ti-hidden" data-state="prev"></div>
							<div class="ti-arrow-next" data-state="next"></div>
						</div>
						<div class="ti-card-media-thumbnails">
							<div class="ti-card-media-thumbnails-inner">${thumbnailsHtml}</div>
						</div>
					</div>
				`, 'text/html').querySelector('.ti-card-media');

				imageMedia.querySelector('.ti-card-media-thumbnail:first-child').classList.add('ti-active');

				if (1 === images.length) {
					imageMedia.querySelector('.ti-arrow-prev').remove();
					imageMedia.querySelector('.ti-arrow-next').remove();
					imageMedia.querySelector('.ti-card-media-thumbnails').remove();
				}

				reviewContainer.appendChild(imageMedia);
			}

			reviewContainer.appendChild(reviewText);

			if (reviewItem.classList.contains('ti-ai-summary-item')) {
				reviewContainer.classList.add('ti-ai-summary-item');
				reviewContainer.classList.add('ti-lightbox-review-item');
				reviewText.classList.add('ti-review-content');
			} else {
				reviewContainer.setAttribute('data-id', reviewItem.getAttribute('data-id'));
			}

			this.lightbox.reviewsContainerInner.appendChild(reviewContainer);
		});

		this.addWidgetStyles();
		this.addLongScrollEvents();
	}

	createLightbox(html)
	{
		let element = (new DOMParser()).parseFromString(html, 'text/html').querySelector('.ti-widget-lightbox');

		return Trustindex.convertToDialog(element);
	}

	showLightbox()
	{
		// a close animation in progress must not remove the lightbox we are showing right now
		if (this.closeTimeout) {
			clearTimeout(this.closeTimeout);
			delete this.closeTimeout;
		}

		document.body.appendChild(this.lightbox);

		if ('DIALOG' !== this.lightbox.tagName) {
			return;
		}

		// a lightbox removed from the DOM while being open has to be closed before it can be shown as modal again
		if (this.lightbox.open) {
			this.lightbox.close();
		}

		this.registerDialogEvents();
		this.lightbox.showModal();
	}

	registerDialogEvents()
	{
		if (this.lightbox.tiDialogEventsRegistered) {
			return;
		}

		this.lightbox.tiDialogEventsRegistered = true;

		// ESC closes the dialog instantly, we close it with our own animation instead
		this.lightbox.addEventListener('cancel', event => {
			event.preventDefault();

			this.close();
		});
	}

	addWidgetStyles()
	{
		if (this.widget.classList.contains('ti-custom-stars')) {
			this.lightbox.classList.add('ti-custom-stars');
		}

		this.lightbox.style.fontFamily = window.getComputedStyle(this.widget.container, null).getPropertyValue('font-family');
	}

	addEvents()
	{
		this.image.onload = () => this.image.parentNode.classList.remove('ti-image-loading');

		let touchstartX, touchmoveX, touchstartY, touchmoveY;
		let isSwiping = false;
		let isScrolling = false;

		this.image.addEventListener('touchstart', (event) => {
			touchstartX = event.touches[0].pageX;
			touchstartY = event.touches[0].pageY;
			touchmoveX = null;
			touchmoveY = null;
			isSwiping = false;
			isScrolling = false;
		}, { passive: true });

		this.image.addEventListener('touchmove', (event) => {
			touchmoveX = event.touches[0].pageX;
			touchmoveY = event.touches[0].pageY;

			let disX = touchmoveX - touchstartX;
			let disY = touchmoveY - touchstartY;

			if (Math.abs(disY) > 10 && !isSwiping) {
				isScrolling = true;
			}

			if (!isScrolling && (Math.abs(disX) > 10 || isSwiping)) {
				isSwiping = true;
			}
		}, { passive: true });

		this.image.addEventListener('touchend', (event) => {
			if (isSwiping && !isScrolling && touchstartX && touchmoveX && Math.abs(touchstartX - touchmoveX) > 25) {
				let index = this.currentIndex - 1;
				if (touchstartX > touchmoveX) {
					index = this.currentIndex + 1;
				}

				this.change(index);
			}

			touchstartX = null;
			touchmoveX = null;
			isSwiping = false;
			isScrolling = false;

			return false;
		}, { passive: true });

		this.lightbox.addEventListener('click', (event) => {
			event.preventDefault();
			event.stopPropagation();

			if (event.target.matches('.ti-arrow-prev')) {
				this.change(this.currentIndex - 1);
			} else if (event.target.matches('.ti-arrow-next')) {
				this.change(this.currentIndex + 1);
			} else if ((event.target.matches('.ti-widget-lightbox') || event.target.matches('.ti-widget-lightbox-close')) && !event.target.closest('.ti-widget-lightbox-inner')) {
				this.close();
			}
		});
	}

	addLongScrollEvents()
	{
		this.lightbox.addEventListener('click', (event) => {
			event.preventDefault();
			event.stopPropagation();

			if (event.target.matches('.ti-arrow-prev')) {
				this.navigateReviewImage(event.target);
			} else if (event.target.matches('.ti-arrow-next')) {
				this.navigateReviewImage(event.target);
			} else if (event.target.matches('.ti-card-media-thumbnail')) {
				this.navigateReviewImage(event.target);
			} else if ((event.target.matches('.ti-widget-lightbox-review-container') || event.target.matches('.ti-widget-lightbox-close')) && !event.target.closest('.ti-review-item')) {
				this.close();
			} else if (event.target.matches('.ti-widget-lightbox-mobile-close-bottom')) {
				this.close();
			} else if (event.target.matches('.ti-show-original-text')) {
				this.widget.TrustindexReviewWidget.showOriginalText(event);
			}
		});

		this.lightbox.addEventListener('keydown', (event) => {
			if ('Escape' === event.key || ('Enter' === event.key && event.target.matches('.ti-widget-lightbox-close'))) {
				this.close();
			}
		});

		let oldContainerAnimatedMoveY = 0;
		let containerAnimatedMoveY = null;
		let touchstartX, touchmoveX, touchstartY, touchmoveY, oldTouchmoveY, touchpagerX;
		let isScrolling = false;
		let isSwiping = false;
		let isPrev = false;
		let isNext = false;
		let isBottomSwipeStarted = false;

		this.reviewMediaContainer = null;

		this.lightbox.reviewsContainer.addEventListener('touchstart', (event) => {
			oldContainerAnimatedMoveY = 0;
			containerAnimatedMoveY = null;
			touchstartX = event.touches[0].pageX;
			touchstartY = event.touches[0].pageY;
			touchmoveX = null;
			touchmoveY = null;
			oldTouchmoveY = null;
			touchpagerX = null;

			isSwiping = false;
			isScrolling = false;
			isBottomSwipeStarted = false;

			this.reviewMediaContainer = event.target.closest('.ti-card-media');
			Trustindex.hide(this.lightbox.mobileCloseBottomSwipe);

			isNext = this.getNavigationArrowState('next');
			isPrev = this.getNavigationArrowState('prev');
		}, { passive: true });

		this.lightbox.reviewsContainer.addEventListener('touchmove', (event) => {
			touchmoveX = event.touches[0].pageX;
			touchmoveY = event.touches[0].pageY;

			let disX = touchmoveX - touchstartX;
			let disY = touchmoveY - touchstartY;
			let deg = Math.abs(Math.atan2(disY, disX) * (180 / Math.PI));

			isScrolling = (isScrolling || (Math.abs(disY) > 4 && deg > 60 && deg < 120)) && !isSwiping;
			isSwiping = (isSwiping || (Math.abs(disX) > 4 && (deg <= 60 || deg >= 120))) && !isScrolling;

			if (isSwiping) {
				if (this.isMoving) {
					return false;
				}

				event.preventDefault();

				if (this.reviewMediaContainer) {
					let direction = touchstartX > touchmoveX ? 'next' : 'prev';
					if (('next' === direction && isNext) || ('prev' === direction && isPrev)) {
						let position = this.reviewMediaContainer.getAttribute('data-position') || '0px';
						touchpagerX = parseInt(position) + disX;

						this.animateReviewImages(position, touchpagerX + 'px', 0);
					}
				}
			}

			oldTouchmoveY = touchmoveY;

			if (!isBottomSwipeStarted) {
				let disBottom = Math.abs((this.lightbox.reviewsContainer.scrollHeight - this.lightbox.reviewsContainer.scrollTop) - this.lightbox.reviewsContainer.clientHeight);
				isBottomSwipeStarted = disBottom < 50 && disY < 0;
			} else if (disY > 0 || isSwiping) {
				this.lightbox.reviewsContainer.style.overflow = '';
				isBottomSwipeStarted = false;
			}

			if (isScrolling && isBottomSwipeStarted) {
				containerAnimatedMoveY = disY + 'px';

				this.lightbox.reviewsContainer.style.overflow = 'hidden';

				this.lightbox.reviewsContainer.animate({
					top: [oldContainerAnimatedMoveY, containerAnimatedMoveY]
				}, {
					duration: Math.abs((parseInt(oldContainerAnimatedMoveY) - parseInt(containerAnimatedMoveY)) / 2),
					fill: 'both',
					easing: 'ease-in-out'
				});

				oldContainerAnimatedMoveY = containerAnimatedMoveY;

				let scale = -(Math.abs(disY) / 2.3);
				if (disY > 0) {
					scale = 0;
				}
				Trustindex.hide(this.lightbox.mobileCloseBottom);
				Trustindex.show(this.lightbox.mobileCloseBottomSwipe, 'inline-block');
				this.lightbox.mobileCloseBottomSwipe.style.setProperty('--scale', scale + 'px');
			}
		}, { passive: false });

		this.lightbox.reviewsContainer.addEventListener('touchend', (event) => {
			if (isSwiping && !isScrolling) {
				let position = touchpagerX;
				if (this.reviewMediaContainer) {
					position = this.reviewMediaContainer.getAttribute('data-position') || '0px';
					isNext = this.getNavigationArrowState('next');
					isPrev = this.getNavigationArrowState('prev');
				}

				if (touchstartX && touchmoveX && Math.abs(touchstartX - touchmoveX) > 25 && touchpagerX) {
					let direction = touchstartX > touchmoveX ? 'next' : 'prev';

					if (('next' === direction && isNext) || ('prev' === direction && isPrev)) {
						let state = parseInt(this.reviewMediaContainer.getAttribute('data-state') || '0');
						let newState = state + ('next' === direction ? 1 : -1);
						this.reviewMediaContainer.setAttribute('data-old-position', position);
						this.reviewMediaContainer.setAttribute('data-position', touchpagerX + 'px');

						this.navigateReviewImage(null, newState);

						this.reviewMediaContainer.removeAttribute('data-old-position');
					} else {
						this.animateReviewImages(touchpagerX + 'px', position, 120);
					}
				} else if (touchpagerX && touchpagerX !== parseInt(position)) {
					this.animateReviewImages(touchpagerX + 'px', position, 120);
				}
			}

			Trustindex.show(this.lightbox.mobileCloseBottom);

			if (isScrolling && containerAnimatedMoveY) {
				this.lightbox.reviewsContainer.style.overflow = '';

				let distance = Math.abs(parseInt(containerAnimatedMoveY));
				let animateTo = 0;

				if (distance > 150 && parseInt(containerAnimatedMoveY) < 0) {
					distance = 500;
					animateTo = '-1000px';

					this.close();
					Trustindex.hide(this.lightbox.mobileCloseBottom);
				}

				this.lightbox.reviewsContainer.scrollTop = this.lightbox.reviewsContainer.scrollHeight;
				this.lightbox.reviewsContainer.animate({
					top: [containerAnimatedMoveY, animateTo]
				}, {
					duration: distance / 2,
					fill: 'both',
					easing: 'ease-in-out'
				});
			}

			this.reviewMediaContainer = null;
			Trustindex.hide(this.lightbox.mobileCloseBottomSwipe);

			oldContainerAnimatedMoveY = 0;
			containerAnimatedMoveY = null;
			touchstartX = null;
			touchmoveX = null;
			oldTouchmoveY = null;
			touchpagerX = null;
			isSwiping = false;
			isScrolling = false;
			isBottomSwipeStarted = false;
		}, { passive: true });
	}

	show(imageElement)
	{
		if (typeof this.lightbox === 'undefined') {
			this.init();
		}

		console.log('[Trustindex Widget: '+this.widget.pid+' - '+this.widget.layoutId+'] lightbox: show');

		this.widget.isLightboxShowing = true;

		document.querySelectorAll('.ti-widget-lightbox').forEach(lightbox => {
			if ('DIALOG' === lightbox.tagName && lightbox.open) {
				lightbox.close();
			}

			lightbox.remove();
		});

		let reviewHash = imageElement.closest('.ti-review-item').getAttribute('data-id');
		let currentIndex = 0, index = parseInt(imageElement.getAttribute('data-image-index'));
		for (let i = 0, l = this.data.length; i < l; i++) {
			if (this.data[i].r === reviewHash && this.data[i].index === index) {
				currentIndex = i;
				break;
			}
		}

		this.showLightbox();

		if (!this.isLongScroll) {
			this.change(currentIndex);
		} else {
			this.lightbox.reviewsContainer.animate({
				top: [0, 0]
			}, {
				duration: 0,
				fill: 'both',
				easing: 'ease-in-out'
			});

			let reviewItem = this.lightbox.querySelector('.ti-review-item[data-id="'+reviewHash+'"]');
			if (reviewItem) {
				let image = reviewItem.querySelector('.ti-card-media .ti-card-media-image img');
				if (image && !image.complete) {
					image.onload = () => reviewItem.scrollIntoView();
				} else {
					reviewItem.scrollIntoView();
				}
			}

			Trustindex.show(this.lightbox.mobileCloseBottom);
			this.lightbox.reviewsContainer.focus();

			Trustindex.profileImageFallback(this.lightbox.reviewsContainer);
		}

		setTimeout(() => this.lightbox.classList.add('ti-widget-lightbox-appeared'), 10);
	}

	close()
	{
		// ESC fires the dialog's cancel event too, so close() can be called more than once for the same lightbox
		if (this.closeTimeout) {
			return;
		}

		console.log('[Trustindex Widget: '+this.widget.pid+' - '+this.widget.layoutId+'] lightbox: close');

		this.lightbox.classList.remove('ti-widget-lightbox-appeared');
		this.closeTimeout = setTimeout(() => {
			delete this.closeTimeout;

			if ('DIALOG' === this.lightbox.tagName && this.lightbox.open) {
				this.lightbox.close();
			}

			this.lightbox.remove();
		}, 300);

		if (this.isLongScroll) {
			Trustindex.hide(this.lightbox.mobileCloseBottomSwipe);
		}

		delete this.widget.isLightboxShowing;
	}

	change(index)
	{
		console.log('[Trustindex Widget: '+this.widget.pid+' - '+this.widget.layoutId+'] lightbox: change');

		this.currentIndex = index;

		this.image.parentNode.classList.add('ti-image-loading');

		this.image.src = this.getImgSrc(this.data[this.currentIndex], this.image.parentNode.offsetHeight);

		if (this.currentReview !== this.data[this.currentIndex].r) {
			this.currentReview = this.data[this.currentIndex].r;
			this.reviewContent.innerHTML = "";

			let reviewItem = this.widget.querySelector('.ti-review-item[data-id="'+this.data[this.currentIndex].r+'"]');
			if (!reviewItem) {
				return;
			}

			let reviewHeader = reviewItem.querySelector('.ti-review-header').cloneNode(true);
			reviewHeader.classList.add('ti-lightbox-review-header');

			let reviewText = reviewItem.querySelector('.ti-review-text-container').cloneNode(true);
			reviewText.setAttribute('class', 'ti-review-text')
			reviewText.setAttribute('style', "");
			reviewText.querySelectorAll('.ti-review-image').forEach(img => img.remove());

			this.reviewContent.appendChild(reviewHeader);
			this.reviewContent.appendChild(reviewItem.querySelector('.ti-stars').cloneNode(true));
			this.reviewContent.appendChild(reviewText);

			this.lightbox.querySelector('.ti-widget-card').setAttribute('class', reviewItem.getAttribute('class').replace('ti-review-item', 'ti-widget-card'));
		}

		Trustindex.hide(this.prevArrow);
		Trustindex.hide(this.nextArrow);

		if (index > 0) {
			Trustindex.show(this.prevArrow);
		}

		if (index < this.data.length - 1) {
			Trustindex.show(this.nextArrow);
		}
	}

	getImgSrc(img, upscale = 600)
	{
		let src = img.src;
		if (!/^(?:https?:)?\/\/[^\/]*google/.test(src)) {
			return src;
		}

		let size = Math.round(upscale * Trustindex.getDevicePixelRatio());
		/* src = src.replace(/=w.+/, '=s' + size);

		if (src.indexOf('=s') !== -1) {
			return src;
		} */

		src = src.replace(/=.+$/, '');

		return src + '=s' + size;
	}

	navigateReviewImage(element, newState)
	{
		if (element) {
			this.reviewMediaContainer = element.closest('.ti-card-media');
			newState = element.getAttribute('data-state');
		}

		if (this.isMoving || !this.reviewMediaContainer) {
			return false;
		}

		let position = this.reviewMediaContainer.getAttribute('data-position') || '0px';
		let state = parseInt(this.reviewMediaContainer.getAttribute('data-state') || '0');
		let imageItems = this.reviewMediaContainer.querySelectorAll('.ti-card-media-images .ti-card-media-image');

		if ('next' === newState || 'prev' === newState) {
			newState = state + ('next' === newState ? 1 : -1);
		} else {
			newState = parseInt(newState);
		}

		let newPosition = (-1 * newState * this.reviewMediaContainer.offsetWidth) + 'px';
		let speed = 500;

		if (this.reviewMediaContainer.getAttribute('data-old-position')) {
			speed = (parseInt(newPosition) - parseInt(this.reviewMediaContainer.getAttribute('data-old-position'))) / speed * (parseInt(newPosition) - parseInt(position));
		}

		this.isMoving = true;

		this.animateReviewImages(position, newPosition, speed);

		let prevIcon = this.reviewMediaContainer.querySelector('.ti-arrow-prev');
		let nextIcon = this.reviewMediaContainer.querySelector('.ti-arrow-next');

		prevIcon.classList.add('ti-hidden');
		nextIcon.classList.add('ti-hidden');

		if (newState > 0) {
			prevIcon.classList.remove('ti-hidden');
		}

		if (newState < imageItems.length - 1) {
			nextIcon.classList.remove('ti-hidden');
		}

		this.reviewMediaContainer.setAttribute('data-state', newState);
		this.reviewMediaContainer.setAttribute('data-position', newPosition);
		this.reviewMediaContainer.querySelectorAll('.ti-card-media-thumbnail').forEach(thumbnail => {
			thumbnail.classList.remove('ti-active');
			if (parseInt(thumbnail.getAttribute('data-state')) === newState) {
				thumbnail.classList.add('ti-active');
			}
		});

		setTimeout(() => {
			this.isMoving = false;
		}, speed);
	}

	animateReviewImages(from, to, speed)
	{
		if (!this.reviewMediaContainer) {
			return false;
		}

		this.reviewMediaContainer.querySelectorAll('.ti-card-media-images .ti-card-media-image').forEach(item => {
			item.animate({
				left: [ from, to ]
			}, {
				duration: speed,
				fill: 'both',
				easing: 'ease-in-out'
			});
		});
	}

	click(event)
	{
		if (
			event.target.matches('.ti-review-image') ||
			('popup' === this.widget.reviewTextMode && event.target.matches('.ti-read-more-active:not(.ti-read-more-collapse'))
		) {
			event.preventDefault();

			this.show(event.target);
		}
	}

	getNavigationArrowState(type)
	{
		if (!this.reviewMediaContainer) {
			return false;
		}

		let element = this.reviewMediaContainer.querySelector('.ti-arrow-' + type);
		if (!element) {
			return false;
		}

		return !element.classList.contains('ti-hidden');
	}
};